<div class="ty-page">
    <div class="ty-card">

        <!-- Animated checkmark -->
        <div class="check-wrap">
            <svg class="check-svg" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                <circle class="check-circle" cx="26" cy="26" fill="none" r="25"/>
                <path class="check-tick" d="M14.1 27.2l7.1 7.2 16.7-16.8" fill="none"/>
            </svg>
        </div>

        <!-- Title -->
        <h1 class="ty-title">Application Submitted!</h1>
        <p class="ty-subtitle">
            Your admission application has been <strong>successfully received</strong>.<br>
            Our team will review it shortly.
        </p>

        <!-- Divider -->
        <div class="ty-divider"></div>

        <!-- Info steps -->
        <div class="ty-steps">
            <div class="ty-step">
                <div class="step-icon">📧</div>
                <div class="step-text">
                    <strong>Check your email</strong>
                    <span>A confirmation has been sent to the registered email address.</span>
                </div>
            </div>
            <div class="ty-step" *ngIf="!isPaid">
                <div class="step-icon">💳</div>
                <div class="step-text">
                    <strong>Payment link incoming</strong>
                    <span>A fee payment link will be sent to the father's email once the application is reviewed.</span>
                </div>
            </div>
            <div class="ty-step" *ngIf="!isPaid">
                <div class="step-icon">✅</div>
                <div class="step-text">
                    <strong>Admission confirmed</strong>
                    <span>Your admission will be confirmed upon successful payment of the admission fee.</span>
                </div>
            </div>
            <div class="ty-step" *ngIf="isPaid">
                <div class="step-icon">⬆️</div>
                <div class="step-text">
                    <strong>Upload Documents</strong>
                    <span>
                        Please check your email inbox. You have received a document upload link for your admission application.
                        Please open the email, click on the provided link, and upload the required admission application documents.
                    </span>
                </div>
            </div>
        </div>

    </div>
</div>
